import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Banner from "../components/banner"
import Tip from "../components/tip"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faFileAlt } from '@fortawesome/free-solid-svg-icons'


const Tips = () => (
    <Layout showContact={true} showFooter={true}>
        <SEO title="Tips" description="Tips and advice for insurance and accidents"/>
        <Banner title="Insurance Tips" description="Tips and advice for insurance and accidents" backgroundCSS="tips-background" />
        <section className="section-container">
            <h1 className="section-title">JUST SO YOU KNOW</h1>
            <div className="tip-list">
                <div data-sal="slide-up"
                    data-sal-duration="1000"
                    data-sal-easing="ease" className="tip">
                    <h3 className="insurance-tip-title" ><span><FontAwesomeIcon className="icon" icon={faUser} size='1x' /></span>IT'S YOUR CHOICE</h3>
                    <p className="tip-description">You have the right to decide which body shop your car goes to. You don't have to follow your insurance suggestion. </p>
                </div>
                <div data-sal="slide-up"
                    data-sal-duration="1000"
                    data-sal-easing="ease" className="tip">
                    <h3 className="insurance-tip-title" ><span><FontAwesomeIcon className="icon" icon={faFileAlt} size='1x' /></span>ONLY NEED ONE ESTIMATE</h3>
                    <p className="tip-description">Insurance companies tend to ask for 3 estimates, but according to the state of Washington, you are only required to provide one estimate. </p>
                </div>
            </div>
        </section>
        <section className="section-container">
            <h1 className="section-title">AFTER AN ACCIDENT</h1>
            <div className="tip-list">
                <Tip number={1} title={"PULL OVER"} description={"safely pull over to the side of the road, turn off your car, and turn on your hazard lights"} />
                <Tip number={2} title={"FIND INJURIES"} description={"See if anyone is injured, including yourself. If injuries appear serious, call 911."} />
                <Tip number={3} title={"TRADE INFO"} description={"Get their name, address, phone number, insurance company, and license plate."} />
                <Tip number={4} title={"TAKE NOTES"} description={"Take photos of the scene, vehicles, damage, the roads, any traffic signs, and the direction "} />
                <Tip number={5} title={"REPORT IT"} description={"call your insurance about the accident. Call the police if there is over $500 in damages"} />
            </div>
        </section>
    </Layout>
)

export default Tips
